import { GUI } from "dat.gui";
import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../assets/models/buttonAnimationScreen.glb";
import gsap from "gsap";

export class ButtonScreenPoint extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.CircleGroup = gltf.scene.getObjectByName("CircleGroup", true);
			this.CircleBig = gltf.scene.getObjectByName("CircleBig", true);
			this.CircleLittle = gltf.scene.getObjectByName("CircleLittle", true);
		});
	}

	helpers() {
		const object = this
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Button Screen");
		const limit = 20;

		folderMostrador.add(object.scale, "x", -limit, limit).step(0.0001).name("Scale X");
		folderMostrador.add(object.scale, "y", -limit, limit).step(0.0001).name("Scale Y");
		folderMostrador.add(object.scale, "z", -limit, limit).step(0.0001).name("Scale Z");

		folderMostrador.add(object.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(object.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(object.position, "z", -limit, limit).step(0.0001).name("Posición Z");

		folderMostrador.add(object.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(object.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(object.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(object, "visible").name("Visible");

		// folderMostrador.add(object.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		// folderMostrador.add(object.scale, "y", -limit, limit).step(0.0001).name("Alto");

		// folderMostrador
		// 	.addColor({ color: object.material.color.getHex() }, "color")
		// 	.name("Color del Material")
		// 	.onChange((value) => {
		// 		object.material.color.set(value);
		// 	});
	}

	onAnimationOpacity() {
		this.clearAnimation()

		this.objectActiveAnimation = this.CircleBig

		// Creamos un objeto con la propiedad de opacidad para poder animarla
		const opacityObject = { opacity: 0.6 };

		// Animación de opacidad de 0.6 a 0.4 y viceversa en bucle
		this.animation = gsap.to(opacityObject, {
			opacity: 0.2,
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				// Actualizamos la opacidad del material en cada fotograma
				this.CircleBig.material.opacity = opacityObject.opacity;
			},
		});

	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null;
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.opacity = 0.6
			this.objectActiveAnimation = null
		}
	}

	renderAnimations() { }
}
